import _ from 'lodash';
import propTypes from 'prop-types';
import React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Col, Row } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../NotificationPopUp';

import commonFunctions from '../../commonFunctions';

import * as authenticationActions from '../../actions/authenticationActions';
import * as commonActions from '../../actions/commonActions';
import * as companyActions from '../../actions/companyActions';
import * as networkActions from '../../actions/networkActions';
import * as reportingActions from '../../actions/reportingActions';
import * as tariffActions from '../../actions/tariffActions';

import AirBnbDateTimePicker from '../common/airBnbDatepicker/AirBnbDateTimePicker';
import SelectInput from '../common/SelectInput';
import TextInput from '../common/TextInput';
import TooltipFormatter from '../common/TooltipFormatter';

class RendicontazioneXSocioSostenitorePage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            commonState: this.props.commonState,
            authenticationState: this.props.authenticationState,
            filters: {
                tariffGroupId: -1,
                avvenutoPagamento: -1,
                startDate: '',
                endDate: ''
            },
            pagingModel: {
                items: [],
                page: 1,
                itemsPerPage: 10,
                total: 0,
                sortName: 'id',
                sortOrder: 'asc'
            },
            gruppi: [],
            tariffs: [],   // legate al socio sostnitore
            avvenutoPagamentoValues: [{ value: -1, text: '---' }, { value: 0, text: 'Da Incassare' }, { value: 1, text: 'Incassata' }]
        };

        if (!authenticationActions.verifyAuthentication(this.props.authenticationState, this.props.history)) {
            return;
        }

        this.contractLinkFormat = this.contractLinkFormat.bind(this);
        this.estrattoContoExport = this.estrattoContoExport.bind(this);
        this.frazionamentoDataFormat = this.frazionamentoDataFormat.bind(this);
        this.gridPrintDate = this.gridPrintDate.bind(this);
        this.gridPrintMoney = this.gridPrintMoney.bind(this);
        this.loadTariffGroupsForSocio = this.loadTariffGroupsForSocio.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onSortChange = this.onSortChange.bind(this);
        this.search = this.search.bind(this);
        this.tooltipFormatter = this.tooltipFormatter.bind(this);
    }

    componentDidMount() {
        this.loadTariffGroupsForSocio();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.commonState !== prevState.commonState || nextProps.authenticationState !== prevState.authenticationState)
            return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState });
        return null;
    }

    contractLinkFormat(cell, row) {
        return <a style={{ cursor: 'pointer' }} href={'#/contractResume/' + row.contractId} target='_blank' rel="noopener noreferrer">{cell}</a>;
    }

    estrattoContoExport() {
        if (this.state.filters.avvenutoPagamento === '1' && (_.isNil(this.state.filters.startDate) || _.isEmpty(this.state.filters.startDate))) {
            notificationPopUp.warning('Seleziona la data di inizio');
            return;
        }

        if (this.state.filters.avvenutoPagamento === '1' && (_.isNil(this.state.filters.endDate) || _.isEmpty(this.state.filters.endDate))) {
            notificationPopUp.warning('Seleziona la data di fine');
            return;
        }

        this.props.reportingActions.estrattoContoXSocioSostenitoreExport(this.state.filters).catch(error => {
            notificationPopUp.error('Problemi nell\'export ');
        });
    }

    frazionamentoDataFormat(cell, row) {
        return commonFunctions.instalmentById(cell).text;
    }

    gridPrintMoney(cell, row) {
        return commonFunctions.numberToItalianEuroFormat(cell);
    }

    gridPrintDate(cell, row) {
        try {
            if (!_.isNil(cell)) {
                var nDate = new Date(cell);
                return commonFunctions.dateToString(nDate);
            }
        }
        catch (err) { }

        return '---';
    }

    loadTariffGroupsForSocio() {
        this.props.tariffActions.loadTariffGroupsForSocio(this.state.authenticationState.network.id).then((res) => {
            const gruppi = res.items.map((value) => { return { value: value.id, text: value.name }; });
            this.setState(Object.assign({}, this.state, { gruppi }));
        }).catch(error => {
            notificationPopUp.error('Problemi nel caricamento dei Gruppi dei Piani Mutualistici');
        });
    }

    onChange(event) {
        const state = Object.assign({}, this.state);
        state.filters[event.target.name] = event.target.value;
        this.setState(state);
    }

    onPageChange(page, sizePerPage) {
        var pagingModel = Object.assign({}, this.state.pagingModel, { page: page, itemsPerPage: sizePerPage });
        this.search(pagingModel);
    }

    onSortChange(sortName, sortOrder) {
        var pagingModel = Object.assign({}, this.state.pagingModel, { sortName: sortName, sortOrder: sortOrder });
        this.search(pagingModel);
    }

    search(toBeUsedPagingModel) {
        if (_.isNil(toBeUsedPagingModel)) {
            toBeUsedPagingModel = this.state.pagingModel;
            toBeUsedPagingModel.page = 1;
        }

        this.props.reportingActions.loadEstrattoContoXSocioSostenitore(this.state.filters, toBeUsedPagingModel).then((pagingModel) => {
            this.setState((state) => { return { pagingModel } });
        }).catch(error => {
            notificationPopUp.error('Problemi nel caricamento degli Incassi');
        });
    }

    tooltipFormatter(cell, row) {
        return (
            <TooltipFormatter text={cell} tooltip={cell} placement="top" />
        );
    }

    render() {
        const resultGridOptions = {
            sizePerPage: this.state.pagingModel.itemsPerPage,
            page: this.state.pagingModel.page,
            sizePerPageList: [5, 10, 20, 50],
            onPageChange: this.onPageChange,
            onSortChange: this.onSortChange
        };

        return (
            <div className="container-fluid" >
                <h1>Estratto Conto Socio Sostenitore</h1>
                <div className="panel panel-default x-panel-gray">
                    <div className="panel-heading">Filtri</div>
                    <div className="panel-body">
                        <Row>
                            <Col md={3}>
                                <SelectInput
                                    label="Piano"
                                    name="tariffGroupId"
                                    defaultOptionText="---"
                                    defaultOptionValue={-1}
                                    onChange={this.onChange}
                                    options={this.state.gruppi}
                                    value={this.state.filters.tariffGroupId} />
                            </Col>
                            <Col md={3}>
                                <TextInput
                                    name='aderente'
                                    label='Socio'
                                    value={this.state.filters.aderente}
                                    onChange={this.onChange} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={3}>
                                <SelectInput
                                    name='avvenutoPagamento'
                                    label='Stato Adesione/Quietanza'
                                    onChange={this.onChange}
                                    value={this.state.filters.avvenutoPagamento}
                                    options={this.state.avvenutoPagamentoValues}
                                />
                            </Col>
                            {this.state.filters.avvenutoPagamento === '1' ? <Col xs={12} md={3}>
                                <AirBnbDateTimePicker
                                    name='startDate'
                                    label='Da'
                                    value={this.state.filters.startDate}
                                    onChange={this.onChange} />
                            </Col> : ''}
                            {this.state.filters.avvenutoPagamento === '1' ? <Col xs={12} md={3}>
                                <AirBnbDateTimePicker
                                    name='endDate'
                                    label='A'
                                    value={this.state.filters.endDate}
                                    onChange={this.onChange} />
                            </Col> : ''}
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <ButtonToolbar>
                                    <ButtonGroup>
                                        <Button bsStyle='primary' onClick={() => this.search()} >Cerca</Button>
                                    </ButtonGroup>
                                    <ButtonGroup>
                                        <Button bsStyle='primary' onClick={() => this.estrattoContoExport()} >Export</Button>
                                    </ButtonGroup>
                                </ButtonToolbar>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="panel panel-default x-panel">
                    <div className="panel-heading">Dettaglio</div>
                    <div className="panel-body">
                        <BootstrapTable data={this.state.pagingModel.items} options={resultGridOptions}
                            fetchInfo={{ dataTotalSize: this.state.pagingModel.total }} remote hover pagination>
                            <TableHeaderColumn dataField='id' isKey hidden>Id</TableHeaderColumn>
                            <TableHeaderColumn dataField='sequence' dataFormat={this.contractLinkFormat}>Adesione</TableHeaderColumn>
                            <TableHeaderColumn dataField='tariffGroupName' dataFormat={this.tooltipFormatter}>Piano Mutualistico</TableHeaderColumn>
                            <TableHeaderColumn dataField='aderente' dataFormat={this.tooltipFormatter}>Socio</TableHeaderColumn>
                            <TableHeaderColumn dataField='instalment' dataSort dataFormat={this.frazionamentoDataFormat}>Frazionamento</TableHeaderColumn>
                            <TableHeaderColumn dataField='accountActivityName' dataSort>Tipo</TableHeaderColumn>
                            <TableHeaderColumn dataField='accountDate' dataSort dataFormat={this.gridPrintDate}>Decorrenza</TableHeaderColumn>
                            <TableHeaderColumn dataField='moneyDate' dataSort dataFormat={this.gridPrintDate} hidden>Scadenza</TableHeaderColumn>
                            <TableHeaderColumn dataField='effectiveDate' dataSort dataFormat={this.gridPrintDate}>Data Incasso</TableHeaderColumn>
                            <TableHeaderColumn dataField='grossAmount' dataSort dataFormat={this.gridPrintMoney}>Contributo</TableHeaderColumn>
                            <TableHeaderColumn dataField='quotaIscrizione' dataSort dataFormat={this.gridPrintMoney}>Quota</TableHeaderColumn>
                            <TableHeaderColumn dataField='networkRights' dataSort dataFormat={this.gridPrintMoney}>Rimborso</TableHeaderColumn>
                            <TableHeaderColumn dataField='rimessoNetwork' dataSort dataFormat={this.gridPrintDate}>Rimessa Rimborso</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        );
    }
}

RendicontazioneXSocioSostenitorePage.propTypes = {
    authenticationState: propTypes.object.isRequired,
    commonState: propTypes.object.isRequired
};

RendicontazioneXSocioSostenitorePage.contextTypes = {
    router: propTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        commonState: state.commonState,
        authenticationState: state.authenticationState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        companyActions: bindActionCreators(companyActions, dispatch),
        authenticationActions: bindActionCreators(authenticationActions, dispatch),
        networkActions: bindActionCreators(networkActions, dispatch),
        reportingActions: bindActionCreators(reportingActions, dispatch),
        tariffActions: bindActionCreators(tariffActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RendicontazioneXSocioSostenitorePage);
